import classNames from 'classnames';

const PlayPauseIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const { className = '', ...attributes } = props;
  const classes = classNames('play-pause-icon', className);

  return (
    <svg viewBox="0 0 640 640" className={classes} {...attributes}>
      <path
        d="M116.5 135.4C107 127.5 93.7 125.7 82.4 131C71.1 136.3 64 147.6 64 160L64 480C64 492.4 71.2 503.7 82.4 509C93.6 514.3 106.9 512.6 116.5 504.6L308.5 344.6C315.8 338.5 320 329.5 320 320C320 310.5 315.8 301.5 308.5 295.4L116.5 135.4zM448 160C448 142.3 433.7 128 416 128C398.3 128 384 142.3 384 160L384 480C384 497.7 398.3 512 416 512C433.7 512 448 497.7 448 480L448 160zM576 160C576 142.3 561.7 128 544 128C526.3 128 512 142.3 512 160L512 480C512 497.7 526.3 512 544 512C561.7 512 576 497.7 576 480L576 160z"
        fill="#7e57c2"
      />
    </svg>
  );
};

export default PlayPauseIcon;
